import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TooltipModule } from "primeng/tooltip";

import { PhonePipe } from "@intocare/pipes";

export interface SupportInfo {
	email?: string;
	phoneNumber?: string;
	url?: string;
	label?: string;
	urlLabel?: string;
}

@Component({
	selector: "ic-support-info-banner",
	templateUrl: "./support-info-banner.component.html",
	styleUrls: ["./support-info-banner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [PhonePipe, TooltipModule],
})
export class SupportInfoBannerComponent {
	supportInfo = input<SupportInfo>();
}
